import { ReactNode, useMemo } from 'react';

import { EnvironmentCountries } from '@e-origin/shared';

import { useSettings } from '@hooks/useSettings';
import { isHighValueDeclaration } from '../utils';

type Hide = 'DMS' | 'DECO' | 'IDMS_LV';

interface HideElementForProps {
  systems?: Hide[];
  declarationGroup?: string;
  children: ReactNode;
  condition?: () => boolean;
}

interface HideElementFunctionProps {
  systems?: Hide[];
  declarationGroup?: string;
  country: string;
  condition?: () => boolean;
}

export const hideElementFunction = ({ systems, declarationGroup, country, condition }: HideElementFunctionProps) => {
  if (condition && !!condition()) {
    return true;
  }

  if (isHighValueDeclaration(declarationGroup) && country === EnvironmentCountries.NL) {
    return systems?.includes('DMS');
  }

  if (!declarationGroup && country === EnvironmentCountries.NL) {
    return systems?.includes('DECO');
  }

  if (!declarationGroup && country === EnvironmentCountries.BE) {
    return systems?.includes('IDMS_LV');
  }

  return false;
};

export const HideElementFor: React.FC<HideElementForProps> = ({ systems, declarationGroup, children, condition }) => {
  const { data: settings } = useSettings();

  const hideElement = useMemo(
    () => hideElementFunction({ systems, declarationGroup, country: settings.country, condition }),
    [systems, declarationGroup, settings.country, condition],
  );

  if (hideElement) return;

  return <>{children}</>;
};
